module.exports = __webpack_public_path__ + "img/geo-tab-table.f9fffc74.svg";